import React, { useRef } from 'react';
import { View, Animated, ScrollView } from 'react-native';

import Item from './item';
import Header from './header/list';
import useStatusBar from '@components/common/useStatusBar';

import { isPhone } from '@helpers';
import { scale } from '@components/frame';

import ColorWrapper from '@styles/colors';

const List = ({
  listWidth,
  data,
  setSelectedNCFile,
  selectedItem,
  C,
  ncFileStatistics,
  generateImageURL,
  selectedTime,
  setSelectedTime,
  selectedMachine,
}) => {
  useStatusBar({
    C,
  });

  const fadeAnim = useRef(new Animated.Value(0)).current;
  const marginTop = scale(20);
  const animationDuration = scale(100);

  return (
    <View
      style={[
        {
          width: isPhone ? '100%' : listWidth,
          backgroundColor: C('Background/Light/System'),
        },
      ]}
      key="machines-scroll"
    >
      <Animated.View
        style={{
          transform: [
            {
              translateY: fadeAnim.interpolate({
                inputRange: [-1, 0, animationDuration, animationDuration + 1],
                outputRange: [0, 0, -animationDuration, -animationDuration],
              }),
            },
          ],
          width: '100%',
          position: 'absolute',
          backgroundColor: C('Background / Light / System'),
          zIndex: 1000,
        }}
      >
        <Header
          {...{
            text: selectedItem?.machineStatus?.shortName,
            backText: selectedMachine?.shortName,
            fadeAnim,
            marginTop,
            animationDuration,
            selectedTime,
            setSelectedTime,
          }}
          key="header"
        />
      </Animated.View>
      <ScrollView
        scrollEventThrottle={8}
        showsVerticalScrollIndicator={false}
        onScroll={Animated.event([{ nativeEvent: { contentOffset: { y: fadeAnim } } }], {
          useNativeDriver: false,
        })}
      >
        <Header
          {...{
            text: selectedItem?.machineStatus?.shortName,
            backText: selectedMachine?.shortName,
            dummy: true,
            marginTop,
            selectedTime,
            setSelectedTime,
          }}
          key="header"
        />
        {data.map((item, index) => (
          <View style={{ position: 'relative' }} key={`ncFileItem-${item.ncFileId}`}>
            <Item
              {...{
                generateImageURL,
                item: {
                  ...item,
                  maxValueActive: ncFileStatistics?.maxValueActive,
                  maxValueProductive: ncFileStatistics?.maxValueProductive,
                },
                setSelectedNCFile,
                nextSelected: data[index + 1] ? data[index + 1].ncFileId === selectedItem?.machineStatus?.ncFileId : false,
                selected: selectedItem?.machineStatus?.ncFileId === item.ncFileId,
                listWidth,
              }}
            />
          </View>
        ))}
      </ScrollView>
    </View>
  );
};

export default ColorWrapper(List);
